import { environment as base } from './environment.release';

export const environment = {
    ...base,
    appId: 'ca.haleo.screener.release',
};
